import { render } from "./FlipIcon.svg?vue&type=template&id=1543ed4d"
const script = {}
script.render = render

export default script